<template>
  <v-avatar :size="size">
    <img v-if="avatarUrl" :src="url" alt="avatar" referrerpolicy="no-referrer" />
    <v-icon v-else :size="size">account_circle</v-icon>
  </v-avatar>
</template>

<script>
import { avatar, isUser } from '@/store/useAuth';
export default {
  name: 'user-avatar',
  props: {
    size: { default: 30 },
    avatarUrl: { default: false },
    user: { default: false }
  },
  data() {
    return {};
  },
  computed: {
    url() {
      return this.avatarUrl ? this.avatarUrl : isUser ? avatar : false;
    }
  }
};
</script>
